export const Base_Url = process.env.REACT_APP_API_BASE_URL;
export const Admin_Base_URL = process.env.REACT_APP_ADMIN_BASE_URL;
export const App_Language = "EN";
export const App_Version = "1.0.0";

export const apiRoutes = {
  submitQuery: "submit-query",
  categories: "category",
  getArticlesInCategory: "articles",
  getParticulatArticle: "article",
  articleSearch: "search?searchTerm=",
};
